import {
  EmailInUseSchoolUserRelation,
  SchoolUserType,
  useCheckUserEmailInUseMutation,
} from '@schooly/api';
import { getEmailInUseSchoolUserRelation } from '@schooly/utils/application-helpers';
import { convertSchoolUserRoleToTextType } from '@schooly/utils/user-helpers';
import { useCallback, useMemo } from 'react';

export type EmailInUseValidation = {
  isValidating: boolean;
  checkUserEmailInUse: (params: {
    email: string;
    schoolId: string;
  }) => Promise<{ email_in_use: boolean }>;
  emailOwner?: EmailInUseSchoolUserRelation;
  emailOwnerType?: SchoolUserType;
  isContactEmail?: boolean;
  isEmailInUse?: boolean;
  checkEmailInUseType: CheckEmailInUseType;
};

export type CheckEmailInUseType = 'school' | 'public';

export const useSchoolEmailInUseValidation = (): EmailInUseValidation => {
  const schoolMutation = useCheckUserEmailInUseMutation();
  const { data: emailInUseData, isLoading: isValidating, mutateAsync } = schoolMutation;

  const { emailOwner, emailOwnerType } = useMemo(() => {
    if (!emailInUseData || emailInUseData.school_user_relations.length === 0) {
      return {};
    }

    const emailOwner = getEmailInUseSchoolUserRelation(emailInUseData.school_user_relations);
    const emailOwnerType = emailOwner
      ? convertSchoolUserRoleToTextType(emailOwner.user_type)
      : undefined;

    return { emailOwner, emailOwnerType };
  }, [emailInUseData]);

  const checkUserEmailInUse: EmailInUseValidation['checkUserEmailInUse'] = useCallback(
    (params) => mutateAsync(params),
    [mutateAsync],
  );

  return {
    isValidating,
    checkUserEmailInUse,
    emailOwner,
    emailOwnerType,
    isEmailInUse: emailInUseData?.email_in_use,
    checkEmailInUseType: 'school',
  };
};
